import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { GetApplicationSectionDetailsResponseType } from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseGetApplicationSectionsDetailsInterface {
  getApplicationSectionsDetailsApi: UseMutateAsyncFunction<
    GetApplicationSectionDetailsResponseType,
    Error,
    {
      applicationNameEnum: string;
    }
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetApplicationSectionsDetails =
  (): UseGetApplicationSectionsDetailsInterface => {
    const { nwApplicationService } = useNwApplicationService();

    const getApplicationSectionsDetails = ({
      applicationNameEnum
    }: {
      applicationNameEnum: string;
    }) => {
      return nwApplicationService.getApplicationSectionsDetails(
        applicationNameEnum
      );
    };

    const { mutateAsync, error, status } = useMutation(
      getApplicationSectionsDetails,
      {
        mutationKey: ['getApplicationSectionsDetailsApi']
      }
    );

    return {
      getApplicationSectionsDetailsApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useGetApplicationSectionsDetails };
